<script setup>
import { useMainStore } from "@/store/main";
import { Close } from "./Icons";

const mainStore = useMainStore();

const isOpen = defineModel();
</script>

<template>
	<div class="success-order">
		<button
			class="form__close-btn"
			@click="isOpen = false"
		>
			<Close />
		</button>
		<h2>Вы успешно записаны!</h2>
		<span>При необходимости менеджеры свяжутся с вами для уточнения деталей</span>

		<a
			v-if="mainStore.newsletterLink"
			:href="mainStore.newsletterLink"
			class="form__newsletter-btn"
		>
			Подписаться на рассылку в MAX
		</a>
	</div>
</template>
<style lang='scss'>
.success-order {
	width: 100%;
	max-width: 920px;
	height: 100%;
	position: relative;
	padding: 94px 32px 0;
	margin: auto;
	display: flex;
	justify-content: flex-start;
	flex-direction: column;
	gap: 32px;
	background: url('public/success_bg-mobile.png');
	background-size: cover;
	background-position: bottom left;
	background-repeat: no-repeat;

	.form__close-btn {
		position: absolute;
		top: 24px;
		right: 24px;
		color: #FFF;
	}

	h2 {
		font-size: 24px;
		color: #FFF;
		font-weight: 700;
	}

	span {
		font-size: 16px;
		text-align: center;
		font-weight: 500;
		text-align: left
	}

	h2,
	span { max-width: 82% }

	@include mq(560px) {
		background-image: url('public/success_bg.png');
		background-position: right;
		padding: 0 90px 0;
		justify-content: center;

		span {
			text-align: left;
			font-size: 18px;
		}

		h2 { font-size: 28px }

		h2,
		span { max-width: 350px }
	}

	@include mq(920px) {
		max-height: 540px;
		gap: 24px;
		border-radius: 20px;
		padding: 150px 90px 0;
		justify-content: flex-start;

		h2 { font-size: 45px }
	}

	.form__newsletter-btn
	{
		padding: 13px 22px;
		background-color: lighten($yellow, 2);
		font-size: 18px;
		font-weight: 500;
		width: max-content;
		color: white;
		border-radius: 12px;
		box-shadow: 0 0 5px 1px rgba(black, 0.2);
		transition: .3s ease box-shadow, .3s ease background-color;

		&:hover
		{
			box-shadow: none;
			background-color: lighten($yellow, 5);
		}
	}
}
</style>